import React from 'react';
import PropTypes from 'prop-types';

import EmployeeCardField from './EmployeeCardField';

const EmployeeCard = ({ employee, employeeFields = [], handleOpenViewModal }) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-lg border-2 border-gray-200 flex items-center">
      <img src="/favicon.ico" alt="Profile" className="w-16 h-16 rounded-full mr-4" />
      <div className="flex-1">
        {employeeFields.length > 0 ? (
          employeeFields.map((field) => (
            <EmployeeCardField
              key={field.key}
              field={field}
              employee={employee}
              handleOpenViewModal={handleOpenViewModal}
            />
          ))
        ) : (
          <p className="text-sm text-gray-500">No fields available.</p>
        )}
      </div>
    </div>
  );
};

EmployeeCard.propTypes = {
  employee: PropTypes.object.isRequired,
  employeeFields: PropTypes.array,
  handleOpenViewModal: PropTypes.func.isRequired,
};

export default EmployeeCard;
